import { TextService } from "../Services/TextService";

/**
 * VAT rates offered on Fortnox invoice forms. 0 % is the default everywhere - Swedish
 * membership fees are momsfria, and we never want to fall through to Fortnox's 25 %
 * predefined rate by accident.
 */
export const FORTNOX_VAT_RATES = [0, 6, 12, 25] as const;

export const DEFAULT_FORTNOX_VAT_RATE = 0;

export const getFortnoxVatOptions = () => {
    const GetText = TextService.GetText;
    return FORTNOX_VAT_RATES.map(rate => ({
        value: rate,
        label: rate === 0 ? GetText("FortnoxInvoice_VatZeroLabel") : `${rate} %`,
    }));
};

export interface VatBreakdown {
    net: number;
    vat: number;
    gross: number;
}

/** amount is the price EXCLUDING VAT (matches the "Belopp exkl. moms" field). */
export const computeVatBreakdown = (amountExclVat: number, vatRatePercent: number): VatBreakdown => {
    const net = Number.isFinite(amountExclVat) ? amountExclVat : 0;
    const rate = Number.isFinite(vatRatePercent) ? vatRatePercent : 0;
    const vat = Math.round(net * rate) / 100;
    return { net, vat, gross: net + vat };
};

export const formatKr = (value: number) =>
    `${value.toLocaleString("sv-SE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} kr`;
